import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function PricingSection() {
  return <section id="checkout" className="radial-green border-y border-lime-700/40 py-10 sm:py-12" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-142" data-mp="19h1fjqzgymny">
      <div className="mx-auto max-w-content px-5" data-id="element-143" data-mp="1j9756u290rzz">
        <div className="mx-auto max-w-xl rounded-3xl border border-lime-700/50 bg-ink-850 p-6 text-center sm:p-9" style={{
        paddingTop: "57px"
      }} data-id="element-144" data-mp="1jb1sug4wmy7r">
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-lime-400" data-id="element-145" data-mp="1s8u6zgyw3ztk">
            Today you pay only
          </p>
          <p className="mt-2 text-5xl font-extrabold tracking-tight text-white sm:text-6xl" data-id="element-146" data-mp="1x9hx80faocmq">
            USD 27
          </p>
          <p className="mt-2 text-sm font-semibold text-white/55" data-id="element-147" data-mp="225gp3xzu0crw">
            One payment · Yours forever · No subscriptions
          </p>

          <div className="mt-5" data-id="element-148" data-mp="7utlm1ej2ypr">
            <CtaButton label="Get my complete Pain Reset now" className="w-full" data-id="element-149" data-mp="7u205jenahd7" />
          </div>

          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-xs font-semibold text-white/50" data-id="element-150" data-mp="1mhzjje2y8nd1">
            <li className="inline-flex items-center gap-1.5" data-id="element-151" data-mp="1cqv5cgl3l6j9">
              <LockIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-152" data-mp="1cr4uk1ybj9nw" />
              Secure payment
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-153" data-mp="17pxnk5402eia">
              <ZapIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-154" data-mp="25e7nmek86s6r" />
              Instant download
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-155" data-mp="20ecyafg3mant">
              <ShieldCheckIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-156" data-mp="1vgbdnq30y3a8" />
              7-day guarantee
            </li>
          </ul>
        </div>
      </div>
    </section>;
}